import Vue from 'vue'

export default Vue.directive('help', function(){
  let handleClick = function (ev, key) {
    let url = `https://interactivevideo.swisstxt.ch/docs/${key !== "undefined" ? key : ''}`
    window.open(url, 'cling-docs')
  }
  return {
    inserted: function (el, binding, vnode) {
      // console.log("inserted", el, binding)
      // store path on element not on vnode context, as vnode.context is the wrapper component around the loop
      el.setAttribute("data-docPath", binding.value)
      let hlp = document.createElement("span")
      hlp.classList.add("_help-wrap")
      hlp.innerHTML = `<i class="material-icons">help</i>`
      if (binding.modifiers.first) {
        let firstEl = el.children[0]
        el.insertBefore(hlp, firstEl)
      } else {
        el.appendChild(hlp)
      }
      hlp.addEventListener('click', ev => {
        handleClick(ev, el.getAttribute("data-docPath"))
      })
    },
    // called when the bindings get updated (e.g. the selected tag changes)
    componentUpdated: function (el, binding, vnode) {
      // console.log("updated", el, binding)
      el.setAttribute("data-docPath", binding.value)
    }
  }
}())